<template>
<div class="additional-resource-choice">
    <label>{{ resource.resourceName }}</label>
    <template v-if="resource.maxQuantity > 1">
        <div class="input-group resource-selection" style="">
            <span class="input-group-btn">
                <button 
                    @click="adjustAdditionalResourceQuantity(false)" 
                    class="btn btn-default" 
                    style="margin-right: -1px;">-</button>
            </span>
            <input type="text" 
                :value="resourceQuantity" 
                class="form-control" 
                style="height: 34px; text-align: center;" 
                disabled="disabled" />
            <span class="input-group-btn">
                <button 
                    @click="adjustAdditionalResourceQuantity(true)" 
                    class="btn btn-default" 
                    style="margin-left: -1px;">+</button>
            </span>
            <span style="" class="input-group-addon">{{ $_locale('pieces', false) }}</span>
        </div>
        <sub class="quantity-warning" style="color:red;" v-show="resource.availableQuantity <= 4 && resource.availableQuantity > 0">
            {{ $_locale('only %s left', true, resource.availableQuantity) }}
        </sub>
    </template>
    <template v-else-if="resource.minQuantity === 1 && resource.maxQuantity === 1">
        <div class="resource-selection">
            <button class="btn btn-sm btn-success btn-block" :disabled="true">{{ $_locale('selected') }}</button>
        </div>
    </template>
    <template v-else>
        <div class="resource-selection">
            <button class="btn btn-sm btn-success btn-block"
                v-if="resourceQuantity === 0" 
                :disabled="resource.availableQuantity === 0" 
                @click="adjustAdditionalResourceQuantity(true)">{{ $_locale('select') }}</button>
            <button class="btn btn-sm btn-warning btn-block"
                v-else 
                @click="adjustAdditionalResourceQuantity(false)">{{ $_locale('remove') }}</button>
        </div>
    </template>
    <sub class="quantity-warning" style="color:red;" v-show="resource.availableQuantity <= 0">
        {{ $_locale('product is out of stock') }}
    </sub>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
    
export default {
    props: {
        resource: {
            type: Object,
            required: true
        },
    },
    watch: {
        resource(val, oldVal) {
            if (oldVal) {
                this.$nextTick(() => {
                    this.$store.commit(
                        'calendar/setAdditionalResourceQuantity', 
                        { amount: 0, row: oldVal, force: true }
                    )
                });
            }
        }
    },
    computed: {
        ...mapGetters({
            additionalResourceQuantity: 'calendar/additionalResourceQuantity',
        }),
        resourceQuantity() {
            const { resourceId } = this.resource;

            return this.additionalResourceQuantity[resourceId] || 0;
        },
    },
    methods: {
        adjustAdditionalResourceQuantity(add) {
            this.$store.commit(
                'calendar/adjustAdditionalResourceQuantity', 
                { add, row: this.resource }
            )
        },
        isAvailable() {
            return this.resource.availableQuantity > 0;
        },
    },
    mounted() {
        
    },
}
</script>